import React from 'react';
import styled from '@emotion/styled';
import { EmotionBreakpoint } from 'dw-au-react-components';

const StyledContentBlock = styled.div`
	h4 {
		font-size: ${(props) => (props.titleFontSize || '32') + 'px'};
		line-height: ${(props) => (props.titleLineHeight || '40') + 'px'};
		letter-spacing: 0.25px;
		color: ${(props) => props.titleColor || '#212121'};
	}

	p {
		font-size: 16px;
		line-height: 24px;
		letter-spacing: 0.15px;
		color: ${(props) => props.copyColor || '#545454'};
	}
`;
const StyledContentBlockItems = styled.div``;
const StyledContentBlockItem = styled.div`
	margin: 10px;
	padding: 39px;
	background-color: ${(props) =>
		props.background || props.backgroundColor || 'white'};

	${EmotionBreakpoint('mobile')} {
		margin: 10px 0;
	}
`;

function ContentBlock({
	props: {
		title,
		titleColor,
		titleAlignment,
		titleFontSize,
		titleLineHeight,
		copy,
		copyColor,
		copyAlignment,
		backgroundColor,
		ctaStyle,
		ctaCopy,
		ctaLink,
		content: { items },
	},
}) {
	return (
		<div className='container'>
			<StyledContentBlock
				titleColor={titleColor}
				copyColor={copyColor}
				titleFontSize={titleFontSize}
				titleLineHeight={titleLineHeight}
			>
				{title && <h4 className={'mb-20 text-' + titleAlignment}>{title}</h4>}
				{copy && <p className={'mb-20 text-' + copyAlignment}>{copy}</p>}
				{items.length > 0 && (
					<StyledContentBlockItems>
						<div className='d-flex justify-content-center align-items-start flex-equal-lg flex-column flex-md-row'>
							{items.map((item, index) => {
								let { title, description, background } = item;
								return (
									<StyledContentBlockItem
										key={index}
										backgroundColor={backgroundColor}
										background={background}
									>
										{title && (
											<div className='subtitle lower mb-12'>{title}</div>
										)}
										{description && <div>{description}</div>}
									</StyledContentBlockItem>
								);
							})}
						</div>
					</StyledContentBlockItems>
				)}
				{ctaCopy ? (
					<div className='mt-24 text-center'>
						{ctaLink ? (
							<a
								href={ctaLink}
								className={`d-inline-block btn btn-${ctaStyle}`}
							>
								{ctaCopy}
							</a>
						) : (
							<button type='button' className={`btn btn-${ctaStyle}`}>
								{ctaCopy}
							</button>
						)}
					</div>
				) : null}
			</StyledContentBlock>
		</div>
	);
}

export default ContentBlock;
